// extracted by mini-css-extract-plugin
export default {"tabPaperContainer":"TabCard_tabPaperContainer__5vnhG"};